import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  type ListCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGetData,
  type ListCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGetError,
  type ListCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGetResponse,
  listCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGet,
} from '../../generated';

export type ListCollectionImageClassificationsQueryVariables =
  ListCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGetData['path'] &
    NonNullable<
      ListCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGetData['query']
    >;

export type ListCollectionImageClassificationsQuery =
  ListCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGetResponse;

export const useListCollectionImageClassificationsQuery = <
  TData = ListCollectionImageClassificationsQuery,
  TError = ListCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGetError,
>(
  { workspace_id, collection_id, source, exclude_source }: ListCollectionImageClassificationsQueryVariables,
  options?: Omit<UseQueryOptions<ListCollectionImageClassificationsQuery, TError, TData>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<ListCollectionImageClassificationsQuery, TError, TData>({
    queryKey: ['ListCollectionImageClassifications', { workspace_id, collection_id, source, exclude_source }],
    queryFn: async () => {
      const { data } =
        await listCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGet(
          {
            path: { workspace_id, collection_id },
            query: { source, exclude_source },
            throwOnError: true,
          },
        );
      return data ?? [];
    },
    ...options,
  });
};

useListCollectionImageClassificationsQuery.getKey = ({
  workspace_id,
  collection_id,
  source,
  exclude_source,
}: ListCollectionImageClassificationsQueryVariables) => [
  'ListCollectionImageClassifications',
  { workspace_id, collection_id, source, exclude_source },
];

useListCollectionImageClassificationsQuery.fetcher = ({
  workspace_id,
  collection_id,
  source,
  exclude_source,
}: ListCollectionImageClassificationsQueryVariables) => {
  return async () => {
    const { data } =
      await listCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGet(
        {
          path: { workspace_id, collection_id },
          query: { source, exclude_source },
          throwOnError: true,
        },
      );
    return data ?? [];
  };
};
